/**
 * Tells a facility change the user asked for apart from one they did not.
 *
 * The user's own switches all go through useFacilitySwitcher().switchFacility (the toolbar's
 * facility list, the corporate dashboard, "Switch back" on a pinned page), which marks the target
 * here just before it selects it. Anything else that changes the facility (the sign-in resolve on
 * a reload, a facility that is no longer mapped) is not marked.
 *
 * useFacilityPinned reads it: a page with work open quietly follows a switch the user made (the
 * toolbar has already asked about unsaved changes), and stops with a notice for one they did not.
 */

let seq = 0;
let last: { facilityId: number; seq: number } | null = null;

/** Called by switchFacility just before it selects `facilityId`. */
export function markDeliberateFacilitySwitch(facilityId: number): void {
  seq += 1;
  last = { facilityId, seq };
}

/** The current mark; a pin remembers it to tell later switches from earlier ones. */
export function deliberateSwitchSeq(): number {
  return seq;
}

/** True when the user switched to `facilityId` themselves after mark `sinceSeq`. */
export function wasDeliberateSwitchSince(facilityId: number, sinceSeq: number): boolean {
  return !!last && last.facilityId === facilityId && last.seq > sinceSeq;
}

/** Test hook. */
export function resetFacilityChangeIntent(): void {
  seq = 0;
  last = null;
}
